import React from 'react';
import { Box, ButtonBase, Typography } from '@mui/material';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import { alpha } from '@mui/material/styles';
import colors from '../../assets/theme/colors';
import { buildAppointmentDraftFromCareSources } from './appointmentCaptureSuggestion';

const AppointmentCaptureScheduleAction = ({ sources = [], canManage = false, timeZone = '', onReview }) => {
  if (!canManage) return null;
  const appointmentDraft = buildAppointmentDraftFromCareSources(sources, new Date(), timeZone);
  if (!appointmentDraft) return null;

  const scheduled = Boolean(appointmentDraft.id);
  const scheduledDateLabel = appointmentDraft.date
    ? new Date(`${appointmentDraft.date}T12:00:00`).toLocaleDateString(undefined, { month: 'short', day: 'numeric' })
    : '';
  const detail = [appointmentDraft.provider, appointmentDraft.date || 'Date needed', appointmentDraft.time].filter(Boolean).join(' · ');
  return <Box sx={{ my: 0.75 }}>
    <ButtonBase aria-label={scheduled ? 'View appointment in Schedule' : 'Review appointment'} onClick={() => onReview?.(appointmentDraft)} sx={{ width: '100%', px: 1.1, py: 0.8, borderRadius: 2, justifyContent: 'space-between', bgcolor: alpha(colors.semantic.sageMist, 0.72), color: colors.semantic.sageDeep, textAlign: 'left' }}>
      <Box>
        <Typography sx={{ fontSize: '0.76rem', fontWeight: 900 }}>{scheduled ? `Appointment scheduled${scheduledDateLabel ? ` for ${scheduledDateLabel}` : ''}` : 'Possible appointment · Needs review'}</Typography>
        {detail ? <Typography sx={{ mt: 0.15, fontSize: '0.75rem', color: colors.semantic.ink2 }}>{detail}</Typography> : null}
      </Box>
      <ChevronRightRoundedIcon />
    </ButtonBase>
  </Box>;
};

export default AppointmentCaptureScheduleAction;
